import { Button, Typography } from '@neo4j-ndl/react';
import type { AnalyticsTrackPayload } from '@nx/analytics-service';
import { DATA_API_EVENTS } from '@nx/analytics-service';
import { APP_SCOPE } from '@nx/constants';
import { useActiveProject, useTrackEvent } from '@nx/state';
import { Center } from '@nx/ui';
import { useNavigate } from 'react-router';

import NoInstanceIllustrationSvg from '../assets/no-instance-illustration.svg';

export const NoInstancesState = () => {
  const track = useTrackEvent<AnalyticsTrackPayload & { event: DATA_API_EVENTS }>();
  const navigate = useNavigate();
  const activeProject = useActiveProject();
  const instancesRoute = `/projects/${activeProject.id}/instances`;
  const navigateToInstances = () => {
    void navigate({ pathname: `${instancesRoute}` });
  };

  return (
    <Center>
      <img src={NoInstanceIllustrationSvg} className="h-[160px] w-[160px]" draggable="false" />
      <div className="ml-12 flex max-w-[430px] flex-col gap-4">
        <Typography variant="h3">No AuraDB instance found</Typography>
        <Typography variant="body-large">
          There are no compatible AuraDB instances available for use with the GraphQL Data API.
        </Typography>
        <Typography variant="body-large">
          GraphQL Data APIs can only be used with a running version 5 or newer AuraDB instance of type Professional or
          Business Critical.
        </Typography>
        <Button
          className="w-fit"
          onClick={() => {
            track({
              event: DATA_API_EVENTS.NAV_TO_CREATE_INSTANCE,
              scope: APP_SCOPE.dataApi,
            });
            navigateToInstances();
          }}
          fill="filled"
          htmlAttributes={{
            tabIndex: 0,
          }}
        >
          Create Instance
        </Button>
      </div>
    </Center>
  );
};
